import confetti from 'canvas-confetti';

const cssVar = (name: string, fallback: string) => {
  if (typeof window === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
};

export const fireConfetti = (canvas: HTMLCanvasElement) => {
  const cannon = confetti.create(canvas, { resize: true, useWorker: true });

  const colors = [
    cssVar('--accent-details-1', '#38bdf8'),
    cssVar('--accent-details-2', '#fbcf24'),
    cssVar('--accent-details-3', '#3ce9ce'),
    cssVar('--accent-details-4', '#5eead4'),
  ];

  const fire = (particleRatio: number, opts: confetti.Options) =>
    cannon({
      origin: { x: 0.5, y: 0.8 },
      colors,
      disableForReducedMotion: true,
      ...opts,
      particleCount: Math.floor(120 * particleRatio),
    });

  fire(0.25, { spread: 26, startVelocity: 35 });
  fire(0.2, { spread: 60, startVelocity: 30 });
  fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8, startVelocity: 30 });
  fire(0.1, { spread: 120, startVelocity: 18, decay: 0.92, scalar: 1.2 });
  fire(0.1, { spread: 120, startVelocity: 28 });

  return cannon;
};
